module.exports = __webpack_public_path__ + "img/huaxue.de03f571.png";